// extracted by mini-css-extract-plugin
export default {"actionMenu":"styles-module__actionMenu__src-labstep-web-core-DataGrid-CellRenderer-ActionMenu-_c0dpf"};